// extracted by mini-css-extract-plugin
export default {"dropdownAccount":"DropdownAccount__dropdownAccount--30q","dropdownAccountIcon":"DropdownAccount__dropdownAccountIcon--1nQ","icon":"DropdownAccount__icon--NEC"};